<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="10.137" height="8.002" viewBox="0 0 10.137 8.002">
		<g id="Group_29879" data-name="Group 29879" transform="translate(-1077.414 -452)">
			<path
				id="Union_65"
				data-name="Union 65"
				d="M16428.449,10119h-5.533a.5.5,0,0,1-.422-.771l2.938-4.573a.5.5,0,0,1,.842,0l2.363,3.688,1.2-1.745a.5.5,0,0,1,.824,0l1.8,2.618a.5.5,0,0,1-.412.784Z"
				transform="translate(-15345 -9659)"
				fill="#5a677c"
			/>
			<circle id="Ellipse_455" data-name="Ellipse 455" cx="1.5" cy="1.5" r="1.5" transform="translate(1084 452)" fill="#5a677c" />
		</g>
	</svg>
</template>

<script>
export default {
	name: 'ImageIndicatorSVG',
};
</script>

<style scoped lang="scss"></style>
